import BOOK_STATUS from '../../data/book_status';
import {
  READING_ACTION_TYPES,
  ACTIVITY_ACTION_TYPES,
  POST_READING_ACTION_TYPES,
  GRAPHIC_ORGANIZER_ACTION_TYPES,
  EVIDENCE_TAGGING_ACTION_TYPES,
} from '../actions/action_types';

export const initState = {
  // should only be updated at the start of a session
  totalQuestions: 0,
  // correct on first try only
  totalCorrect: 0,
  // totalIncorrect will only increment once per question
  totalIncorrect: 0,
  // totalResponses is not just correct + incorrect, could answer incorrect
  // multiple times
  totalResponses: 0,
  // totalInstruction here tracks if we're in the try again loop.
  // 0 = first attempt, 1 = try again
  totalInstruction: 0,
};

export default (state = initState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK_STATE:
      if (payload.accurateResponseData.totalQuestions && payload.accurateResponseData.totalQuestions > 0) {
        if (payload.status !== BOOK_STATUS.IN_PROGRESS) {
          return {
            ...initState,
            totalQuestions: state.totalQuestions,
          };
        }
        return {
          ...payload.accurateResponseData,
          totalQuestions: state.totalQuestions,
        };
      }
      return {
        ...initState,
      };

    // assume this always happens before set_total_questions
    case POST_READING_ACTION_TYPES.SET_ALL_QUESTIONS:
      return {
        ...state,
        totalQuestions: payload.length,
      };

    case ACTIVITY_ACTION_TYPES.SET_TOTAL_QUESTIONS:
      return {
        ...state,
        totalQuestions: payload,
      };

    case ACTIVITY_ACTION_TYPES.ANSWER_CORRECT:
      return {
        ...state,
        totalCorrect: state.totalCorrect + 1,
      };

    case ACTIVITY_ACTION_TYPES.ANSWER_INCORRECT:
      return {
        ...state,
        totalIncorrect: state.totalIncorrect + 1,
      };

    case ACTIVITY_ACTION_TYPES.ANSWER:
    case GRAPHIC_ORGANIZER_ACTION_TYPES.ANSWER:
    case POST_READING_ACTION_TYPES.ANSWER:
    case EVIDENCE_TAGGING_ACTION_TYPES.ANSWER:
      return {
        ...state,
        totalResponses: state.totalResponses + 1,
      };

    case READING_ACTION_TYPES.TRY_AGAIN:
      return {
        ...state,
        totalInstruction: 1,
      };

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initState;

    default:
      return state;
  }
};
